
import { defineComponent, PropType, ref } from 'vue'
import GreetingCard from '@/components/GreetingCard.vue'
import { IChainId } from '@/interface'
import { ITokenInfoRes } from '@/composables/fxwallet'
export default defineComponent({
  components: {
    GreetingCard
    // ChainTag,
    // AccountConnect
  },

  props: {
    butQuantity: {
      type: Number as PropType<number>,
      required: true
    }
  },

  setup (props, { emit }) {
    document.body.scrollTop = 0
    return {}
  }
})
